import moment from "moment";
import { harvestYearDetail } from "../../config/harvestYearDetail";
import { userDetail } from "../../config/userDetails";
import { globalApiHandler } from "../../services/services";

export const DESTINATION = {
  getAllDestList: {
    success: "DESTINATION_GET_ALL_SUCCESS",
    error: "DESTINATION_GET_ALL_ERROR"
  },
  create: {
    success: "DESTINATION_CREATE_SUCCESS",
    error: "DESTINATION_CREATE_ERROR"
  },
  edit: {
    success: "DESTINATION_EDIT_SUCCESS",
    error: "DESTINATION_EDIT_ERROR"
  },
  update: {
    success: "DESTINATION_UPDATE_SUCCESS",
    error: "DESTINATION_UPDATE_ERROR"
  },
  delete: {
    success: "DESTINATION_DELETE_SUCCESS",
    error: "DESTINATION_DELETE_ERROR"
  }
};

export const destListAction = (type, harvestYear=harvestYearDetail().name) => {
  return (dispatch,getState) => {
    const selectedMainFarm = getState().FarmManagementReducer.MainFarmId
    /* in case of superAdmin no parentFarmId is associated therefore using selectedMainFarm
      from mainFarm Dropdown*/
  let url = `/ntrac/destination/destinationType/${
    userDetail().parentFarmId ? userDetail().parentFarmId : selectedMainFarm
  }/${harvestYear}?destinationType=${type}`;
    globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data.data;
        data.map(item => {
          item.updatedAt = moment(item.updatedAt).format('ll');
          item.type = item.destinationTypeDTO.type;
          item.commodityName=item.commodity==null?"":item.commodity.commodityName;
          item.varietyName=item.commodityVariety==null?"":item.commodityVariety.varietyName;
        });
        dispatch({ type: DESTINATION.getAllDestList.success, data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const createDestAction = destInfo => {
  let url = `/ntrac/destination`;
  return dispatch => {
    globalApiHandler(url, "post", destInfo)
      .then(response => {
        dispatch({ type: DESTINATION.create.success, data: response.data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const editDestAction = data => {
  return dispatch => {
    dispatch({ type: DESTINATION.edit.success, data });
  };
};

export const updateDestAction = destInfo => {
  let url = `/ntrac/destination/${destInfo.id}`;
  return dispatch => {
    globalApiHandler(url, "put", destInfo)
      .then(response => {
        dispatch({ type: DESTINATION.update.success, data: response.data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const deleteDestAction = (id,harvestYear=harvestYearDetail().name) => {
  let url = `/ntrac/destination/${id}?harvestYear=${harvestYear}`;
  return dispatch => {
    globalApiHandler(url, "delete", {})
      .then(response => {
        const data = response.data.data;
        dispatch({ type: DESTINATION.delete.success, data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/destinations/action.js